module.exports = __webpack_public_path__ + "static/media/PolarisLogoRTL.689c23c1.svg";